/* Peter and May - Demande de retour
   Progressive enhancement du formulaire de sections/pm-return-form.liquid.

   Trois roles, dans cet ordre d'importance :
     1. revelation du bloc articles, masque cote serveur tant que ce script n'a
        pas pris la main. Des cases a cocher qui ne partiraient nulle part
        seraient un mensonge fait au client ;
     2. synchronisation commande -> articles, et agregation des articles coches
        dans l'input cache, pour que l'email du marchand porte UNE ligne lisible
        plutot qu'une par article ;
     3. validation a la soumission, avec un recapitulatif qui prend le focus.

   Les messages d'erreur viennent de `validationMessage`, que le navigateur rend
   deja dans la langue du visiteur. Les traduire nous-memes ajouterait des cles
   de locale pour un resultat moins bon que le natif. */

(function () {
  'use strict';

  function initForm(form) {
    /* Le Liquid laisse deliberement la validation native active, pour qu'un
       visiteur sans JS reste protege. On ne la desarme qu'ici, au moment ou ce
       script est capable de la remplacer par des messages en ligne. */
    form.setAttribute('novalidate', 'novalidate');

    var orderSelect = form.querySelector('[data-return-order-select]');
    var itemsBlock = form.querySelector('[data-return-items]');
    var itemsValue = form.querySelector('[data-return-items-value]');
    var manualOrder = form.querySelector('[data-return-manual-order]');
    var summary = form.querySelector('[data-return-summary]');
    var summaryList = form.querySelector('[data-return-summary-list]');
    var submit = form.querySelector('[data-return-submit]');

    /* --- Articles --- */

    function visibleBoxes() {
      if (!itemsBlock) return [];
      return Array.prototype.filter.call(
        itemsBlock.querySelectorAll('[data-return-item]'),
        function (box) {
          var list = box.closest('[data-order-items]');
          return list && !list.hidden;
        }
      );
    }

    function syncItemsValue() {
      if (!itemsValue) return;
      itemsValue.value = visibleBoxes()
        .filter(function (box) { return box.checked; })
        .map(function (box) { return box.value; })
        .join(', ');
    }

    function showOrderItems(key) {
      if (!itemsBlock) return;
      var lists = itemsBlock.querySelectorAll('[data-order-items]');
      var matched = false;

      Array.prototype.forEach.call(lists, function (list) {
        var isMatch = list.getAttribute('data-order-items') === key;
        list.hidden = !isMatch;
        if (isMatch) matched = true;
        /* Une commande qu'on quitte ne doit pas laisser ses articles dans
           l'envoi : on decoche ce qui redevient invisible. */
        if (!isMatch) {
          Array.prototype.forEach.call(list.querySelectorAll('[data-return-item]'), function (box) {
            box.checked = false;
          });
        }
      });

      itemsBlock.hidden = !matched;
      syncItemsValue();
    }

    if (itemsBlock && orderSelect) {
      /* Le bloc reste masque tant qu'aucune commande n'est choisie : afficher
         une liste vide sous un intitule « articles concernes » n'aide personne. */
      itemsBlock.hidden = true;

      orderSelect.addEventListener('change', function () {
        var option = orderSelect.options[orderSelect.selectedIndex];
        var key = option ? option.getAttribute('data-order-key') : null;

        if (manualOrder) manualOrder.hidden = key !== 'other';
        showOrderItems(key === 'other' ? null : key);
      });

      itemsBlock.addEventListener('change', function (event) {
        if (event.target.hasAttribute('data-return-item')) syncItemsValue();
      });
    }

    /* La saisie libre ne sert qu'a la commande absente de la liste. Elle part
       masquee, mais seulement une fois le JS actif : sans lui, elle doit rester
       accessible. */
    if (manualOrder && orderSelect) manualOrder.hidden = true;

    /* --- Validation --- */

    function fieldError(field) {
      return form.querySelector('[data-error-for="' + field.id + '"]');
    }

    function clearError(field) {
      var slot = fieldError(field);
      field.removeAttribute('aria-invalid');
      if (slot) {
        slot.hidden = true;
        slot.textContent = '';
      }
    }

    function showError(field) {
      var slot = fieldError(field);
      field.setAttribute('aria-invalid', 'true');
      if (slot) {
        slot.textContent = field.validationMessage;
        slot.hidden = false;
      }
    }

    function labelFor(field) {
      var label = form.querySelector('label[for="' + field.id + '"]');
      return label ? label.textContent.replace('*', '').trim() : field.name;
    }

    /* Une erreur ne s'affiche qu'apres une premiere tentative d'envoi : signaler
       « champ obligatoire » sur un champ que le visiteur n'a pas encore atteint
       est du bruit, pas de l'aide. */
    var submitted = false;

    Array.prototype.forEach.call(form.elements, function (field) {
      if (!field.id || typeof field.checkValidity !== 'function') return;
      field.addEventListener('input', function () {
        if (submitted && field.checkValidity()) clearError(field);
      });
      field.addEventListener('blur', function () {
        if (!submitted) return;
        if (field.checkValidity()) clearError(field);
        else showError(field);
      });
    });

    form.addEventListener('submit', function (event) {
      submitted = true;
      syncItemsValue();

      var invalid = Array.prototype.filter.call(form.elements, function (field) {
        return field.id && typeof field.checkValidity === 'function' && !field.checkValidity();
      });

      Array.prototype.forEach.call(form.elements, function (field) {
        if (field.id && typeof field.checkValidity === 'function' && field.checkValidity()) {
          clearError(field);
        }
      });

      if (invalid.length === 0) {
        if (submit) {
          submit.disabled = true;
          submit.setAttribute('aria-busy', 'true');
          var label = submit.querySelector('[data-return-submit-label]');
          var busy = submit.getAttribute('data-submitting-label');
          if (label && busy) label.textContent = busy;
        }
        if (summary) summary.hidden = true;
        return;
      }

      event.preventDefault();
      invalid.forEach(showError);

      if (summary && summaryList) {
        summaryList.textContent = '';
        invalid.forEach(function (field) {
          var li = document.createElement('li');
          var link = document.createElement('a');
          link.href = '#' + field.id;
          link.textContent = labelFor(field);
          link.addEventListener('click', function (clickEvent) {
            clickEvent.preventDefault();
            field.focus();
          });
          li.appendChild(link);
          summaryList.appendChild(li);
        });
        summary.hidden = false;
        summary.focus();
      } else {
        invalid[0].focus();
      }
    });
  }

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.pm-return-form__form'),
      initForm
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* L'editeur de theme recharge la section sans recharger la page. */
  document.addEventListener('shopify:section:load', function (event) {
    Array.prototype.forEach.call(
      event.target.querySelectorAll('.pm-return-form__form'),
      initForm
    );
  });
})();
